import React from "react";
import TestimonialSectionabout from "../pages/TestimonialSectionabout";
import WideRangeSection from "../pages/WideRangeSection";
import VisionMission from "../pages/VisionMission";

const AboutUs = () => {
  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title">About Velocity Cab</h2>
            </div>
          </div>
        </div>
      </div>

      {/* About Us Section */}
      <div
        className="section-full site-bg-white twm-abus-section-wrap wow fadeInDown"
        data-wow-offset="100"
        data-wow-delay="0.2"
      >
        <div className="container">
          <div className="row twm-abus-section">

            {/* Left Media */}
            <div className="col-lg-7 col-md-12">
              <div className="twm-abus-left">
                <div className="twm-media">
                  <img src="/images/car.jpeg" alt="About Velocity Cab" />

                  {/* <div className="twm-abus-video">
                    <a href="https://vimeo.com/337649532" className="mfp-video">
                      <i className="icon fa fa-play"></i>
                    </a>
                  </div> */}

                  <div className="twm-abus-year-section">
                    <div className="tem-abus-year-content">
                      <span>Since</span>
                      <h2 className="year-title">2016</h2>
                    </div>
                  </div>
                </div>

                
           <div className="twm-inline-list2">
  <ul>
    <li><i className="fa fa-check darkcolorrr"></i> Wide Range of Cars and Bikes Available</li>
    <li><i className="fa fa-check darkcolorrr"></i> 24/7 Customer Support & Roadside Assistance</li>
    <li><i className="fa fa-check darkcolorrr"></i> Trusted by Thousands of Satisfied Customers</li>
  </ul>
</div>

                {/* <div className="twm-media2">
                  <img src="/images/car.png" alt="Vehicle" />
                </div> */}
              </div>
            </div>

            {/* Right Content */}
            <div className="col-lg-5 col-md-12">
              <div className="section-head left aside-section">
                <div className="twm-sm-title left">About Us</div>
                <h2 className="twm-large-title site-text-dark">
                  Reliable, Safe & Comfortable Rides
                </h2>
               

<div className="section-head-detail">
  <p>
    Velocity Cab has been dedicated to providing safe, reliable, and comfortable transportation across cities. With a fleet of meticulously maintained vehicles and a team of highly professional drivers, we ensure every journey is smooth, punctual, and stress-free.

    Our mission is to redefine urban travel, making it convenient and accessible for everyone – from daily commuters and business travelers to tourists exploring new destinations. We prioritize safety, comfort, and customer satisfaction in every ride.
  </p>
<br/>
<p>
  Founded in 2016 by Mr. Siddhedhwar Shete, Velocity Cab was established with a vision to make travel more reliable and comfortable. Over the years, it has grown into a trusted transportation service known for its commitment to quality and customer satisfaction.

  Under his leadership, the company continues to improve its services by expanding its fleet and maintaining high standards, making it a preferred choice for safe and dependable travel.
</p>
</div>



              </div>

              {/* <div className="twm-inline-list2">
                <ul>
                  <li>Wide Range of Cars and Bikes Available</li>
                  <li>24/7 Customer Support & Roadside Assistance</li> 
                  <li>Trusted by Thousands of Satisfied Customers</li>
                </ul>
              </div> */}
            </div>

          </div>
        </div>
      </div>

      {/* Additional Sections */}
      <VisionMission/>
      <WideRangeSection />
      <TestimonialSectionabout />
    </>
  );
};

export default AboutUs;